<template>
	<page>
		<div class="info">
			<div class="info-item flex-between">
				<label>账号：</label>
				<p>{{userInfo.user_name}}</p>
			</div>
			<div class="info-item flex-between">
				<label>姓名：</label>
				<p>{{userInfo.user_realname}}</p>
			</div>
			<div v-if="SYS == 'staff'" class="info-item flex-between">
				<label>所属部门：</label>
				<p>{{userInfo.department_name}}</p>
			</div>
			<div v-else class="info-item flex-between">
				<label>公司名称：</label>
				<p>{{userInfo.customer_name}}</p>
			</div>
		</div>

		<c-button v-if="SYS == 'staff'" class="button" size="form" color="main" @click="resetPassword">修改登录密码</c-button>
		<c-button class="button" size="form" color="red" @click="logout">退出登录</c-button>
		
		<c-dialog ref="resetPsw" title="修改密码">
			<c-form ref="resetPswForm">
				<c-form-item label="旧密码" required>
					<c-input type="password" name="old_pwd" visible></c-input>
				</c-form-item>
				<c-form-item label="新密码" required>
					<c-input type="password" name="user_pwd" visible></c-input>
				</c-form-item>
				<c-form-item label="确认密码" required>
					<c-input type="password" name="confirm_pwd" visible></c-input>
				</c-form-item>
			</c-form>
		</c-dialog>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	import {cryptoJs} from '@deanwu/vue-component-library-mobile'

	export default {
		computed: {
			...mapState(['userInfo'])
		},

		methods: {
			resetPassword() {
				this.$refs.resetPswForm.clear();
				this.$refs.resetPsw.open({
					resolve: (stop, next) => {
						stop();
						this.$refs.resetPswForm.submit({
							url: '/sys_user/update_pwd',
							rule: {
								old_pwd: '请填写旧密码',
								user_pwd: '请填写新密码',
								confirm_pwd: [{
									type: 'empty',
									message: '请在填写一次新密码'
								}, {
									type: 'function',
									fun: (value, data) => {
										return data.user_pwd == value
									},
									message: '两次输入的新密码不一致'
								}]
							},
							dataFormatter: data => {
								data.old_pwd = cryptoJs.MD5(data.old_pwd).toString();
								data.user_pwd = cryptoJs.MD5(data.user_pwd).toString();
								delete data.confirm_pwd;
								return data;
							},
							success: () => {
								this.$message({
									type: 'success',
									message: '密码修改成功'
								});
								next();
							}
						});
					}
				})
			},

			logout() {
				this.$confirm({
					message: '确定要退出登录吗？',
					resolve: () => {
						this.request({
							url: '/sys_user/logout',
							loading: true,
							success: () => {
								this.$store.commit('setSession', '');
								this.mp.reLaunch('/pages/login/index');
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.info {
		border-radius: 8px;
		padding: .36rem .42rem;
		margin: .24rem;
		background: #fff;

		&-item {
			padding: .15rem 0;
			line-height: .42rem;
			font-size: .3rem;

			label {
				color: #999;
			}

			p {
				width: 4.5rem;
				text-align: right;
			}
		}
	}

	.button {
		width: 7.02rem;
		margin: 0 .24rem .24rem;
	}
</style>